var __vue_script__, __vue_template__
__vue_script__ = require("-!babel-loader!../../../node_modules/vux-loader/src/script-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./header.vue")
__vue_template__ = require("-!vue-html-loader!../../../node_modules/vux-loader/src/template-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./header.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }



//////////////////
// WEBPACK FOOTER
// ./src/component/near_powerstation/header.vue
// module id = 47
// module chunks = 1 2 3 4 5 6 7 10 12 13 16 22 23 24 26 27